import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { MainHeader, Breadcrumb, MainFooter } from "../../components";

function Aboutus() {
    const breadcrumb = [
        {
            path: '/Home',
            name: 'Home',
        },
        {
            path: '#',
            name: 'About Us',
        },
    ];
    return (
        <>       
            <MainHeader/>
            <main className="aboutPage">
                <Container>
                    <Breadcrumb title="About Us" breadcrumb={breadcrumb}/>
                    <div className="aboutPage_inner">
                        <p className="text-750">Good Guys Home Services was founded and co-founded by a group of technicians working in the field. After years of working in the trade industry, they realize there was a better way to connect customers with the technicians. With a comfort, meet convenience attitude they set out to develop the Good Guys Home Services App and business operating system.</p>
                        <div>
                            <h2 className="aboutPage_title">Core things we focused on</h2>
                        </div>
                        <div className="focuSec">
                            <Row>
                                <Col lg={4} md={6}>
                                    <div className="focuSec_box overflow-hidden">
                                        <div className="focuSec_head">
                                            <h3>Be Efficient</h3>
                                        </div>
                                        <div className="focuSec_body">
                                            <ul className="mb-0 list-unstyled">
                                                <li>Get to customers fast</li>
                                                <li>Provide energy efficient equipment</li>
                                                <li>Have the “Right Technicians”</li>
                                            </ul>
                                        </div>
                                    </div>
                                </Col>
                                <Col lg={4} md={6}>
                                    <div className="focuSec_box overflow-hidden">
                                        <div className="focuSec_head">
                                            <h3>The Right Technicians</h3>
                                        </div>
                                        <div className="focuSec_body">
                                            <ul className="mb-0 list-unstyled">
                                                <li>5 years’ experience in the field</li>
                                                <li>Technically strong and can work on various types of equipment</li>
                                                <li>At their core, believe in being a good person</li>
                                                <li>Enjoys the trade</li>
                                                <li>Someone always improving abilities</li>
                                            </ul>
                                        </div>
                                    </div>
                                </Col>
                                <Col lg={4} md={6}>
                                    <div className="focuSec_box overflow-hidden">
                                        <div className="focuSec_head">
                                            <h3>No Gimmicks</h3>
                                        </div>
                                        <div className="focuSec_body">
                                            <ul className="mb-0 list-unstyled">
                                                <li>Show up and Do the right thing</li>
                                                <li>Nothing is “Free” – not even service calls</li>
                                                <li>No sales process with tier pricing – Industry standard pricing</li>
                                            </ul>
                                        </div>
                                    </div>
                                </Col>
                            </Row>
                        </div>     
                        <p className="mb-0 text-750 ">We make it our goal to ensure you receive a higher standard of service. Good Guy technicians are highly experienced, with each one having a minimum of 5 years experience in the field — so you can rest assured that they have seen and resolved many HVAC, Plumbing and Electrical problems! From small repairs to full unit replacements, our team of efficient, highly trained technicians will be sure to get your comfort levels back to what they should be! And to give you that extra peace of mind when you book online or through the App, we offer a peace of mind satisfaction guarantee. If you are not satisfied, we promise to make it right! They don’t call us the good guys for nothin’.</p>                  
                    </div>
                </Container>
            </main>
            <MainFooter/>
        </>
    );
  }
  
  export default Aboutus;